import { Global } from "../Variables/Global";

// Counts the API requests that are still running, so a page can tell when all of
// its data has arrived (used by ContentReveal to decide when to hide the loader).
let inflight = 0;
let lastActivity = Date.now();
let installed = false;

const finishRequest = () => {
  inflight = Math.max(0, inflight - 1);
  lastActivity = Date.now();
};

export const installNetworkTracker = () => {
  if (installed || typeof window === "undefined" || !window.fetch) return;
  installed = true;
  const originalFetch = window.fetch.bind(window);

  window.fetch = (input, init) => {
    const url = typeof input === "string" ? input : (input && input.url) || "";
    if (!url.startsWith(Global.API_URL)) {
      return originalFetch(input, init);
    }
    inflight += 1;
    lastActivity = Date.now();
    let done = false;
    const finishOnce = () => {
      if (!done) {
        done = true;
        finishRequest();
      }
    };
    return originalFetch(input, init).then(
      (response) => {
        // the request counts as running until its body has been read
        ["json", "text", "blob", "arrayBuffer", "formData"].forEach((method) => {
          const original = response[method] && response[method].bind(response);
          if (!original) return;
          response[method] = () => original().then(
            (value) => { finishOnce(); return value; },
            (error) => { finishOnce(); throw error; }
          );
        });
        // if nobody reads the body, do not wait for it forever
        setTimeout(finishOnce, 3000);
        return response;
      },
      (error) => {
        finishOnce();
        throw error;
      }
    );
  };
};

export const isNetworkIdle = (quietMs = 300) =>
  inflight === 0 && Date.now() - lastActivity >= quietMs;

// lets other work (for example a lazy page chunk being downloaded) count as "not idle"
export const beginPending = () => {
  inflight += 1;
  lastActivity = Date.now();
};
export const endPending = finishRequest;
